import { API } from "aws-amplify";

export const GET_USER_PROFILE_REQUEST = "@@profile/GET_USER_PROFILE_REQUEST";
export const GET_USER_PROFILE_SUCCESS = "@@profile/GET_USER_PROFILE_SUCCESS";
export const GET_USER_PROFILE_FAILURE = "@@profile/GET_USER_PROFILE_FAILURE";

export function getProfile(id = "") {
  return async (dispatch) => {
    if (!id) return;
    dispatch({
      type: GET_USER_PROFILE_REQUEST,
    });
    try {
      const response = await API.get("usimAPI", `/user/${id}`);
      dispatch({
        type: GET_USER_PROFILE_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_USER_PROFILE_FAILURE,
        payload: error,
      });
    }
  };
}
